import React, { useEffect, useRef } from "react";
import Tippy from "@tippyjs/react";
import type { Props } from "tippy.js";
import "./Tooltip.css";

interface TooltipProps {
  children: React.ReactElement;
  contentList: React.ReactElement | (string | null)[];
  offset?: number[];
  placement?: Props["placement"];
  classname?: string;
  delay?: number;
  zIndex?: number;
  duration?: Props["duration"];
  appendTo?: Props["appendTo"];
  hideOnScroll?: boolean;
}

function Tooltip({
  children,
  contentList,
  offset = [],
  placement = "bottom",
  classname = "",
  delay = 300,
  zIndex = 9999,
  duration,
  appendTo = () => document.body,
  hideOnScroll = false,
}: TooltipProps) {
  const scrollHandlerRef = useRef<(() => void) | null>(null);

  const removeScrollListeners = () => {
    const handler = scrollHandlerRef.current;
    if (!handler) return;
    window.removeEventListener("scroll", handler, true);
    window.removeEventListener("resize", handler);
    scrollHandlerRef.current = null;
  };

  useEffect(() => removeScrollListeners, []);

  return (
    <Tippy
      arrow={false}
      interactive={true}
      // trigger="click"
      className={`custom-tooltip ${classname}`}
      zIndex={zIndex}
      placement={placement}
      appendTo={appendTo}
      offset={
        offset
          ? (offset as [number, number])
          : ([] as unknown as [number, number])
      }
      delay={[delay, null]}
      duration={duration}
      onShow={(instance) => {
        if (!hideOnScroll) return;
        removeScrollListeners();
        const handler = () => instance.hide();
        scrollHandlerRef.current = handler;
        window.addEventListener("scroll", handler, true);
        window.addEventListener("resize", handler);
      }}
      onHide={() => {
        removeScrollListeners();
      }}
      content={
        <>
          {React.isValidElement(contentList) ? (
            contentList
          ) : contentList[0] !== null ? (
            <ul className="font-normal text-text-500">
              {contentList.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            <></>
          )}
        </>
      }
    >
      {children}
    </Tippy>
  );
}

export default Tooltip;
